import './corregirCantidad.scss'

// Modal para corregir una cantidad ya registrada en progreso de corte / almacén.
// Devuelve el nuevo valor (entero >= 0) o null si se cancela o no cambia.
// detalleDiff: texto opcional tras la diferencia (p. ej. 'en la última línea del albarán').
export default async function pedirCantidadCorregida(swal, { sku, label, actual, total, detalleDiff = '' }) {
    const { value, isConfirmed } = await swal({
        title: 'Corregir cantidad enviada',
        html: `
            <div class="pm-swal">
                <div class="pm-swal-sku">${sku}</div>
                <div class="pm-swal-label">${label}</div>
                <div class="pm-swal-stepper">
                    <button type="button" class="pm-swal-step" data-step="-1"><i class="fa-solid fa-minus"></i></button>
                    <input id="pm-swal-input" type="number" min="0" step="1" value="${actual}">
                    <button type="button" class="pm-swal-step" data-step="1"><i class="fa-solid fa-plus"></i></button>
                </div>
                <div class="pm-swal-meta">de ${total} uds del pedido</div>
                <div id="pm-swal-diff" class="pm-swal-diff"></div>
            </div>`,
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-secondary ml-1' },
        buttonsStyling: false,
        didOpen: popup => {
            const input = popup.querySelector('#pm-swal-input');
            const diff = popup.querySelector('#pm-swal-diff');
            const pintar = () => {
                const nuevo = Number(input.value) || 0;
                const d = nuevo - actual;
                diff.className = 'pm-swal-diff' + (d > 0 ? ' is-up' : d < 0 ? ' is-down' : '');
                diff.innerHTML = d === 0
                    ? 'Sin cambios'
                    : `<strong>${actual} → ${nuevo}</strong> · ${d > 0 ? '+' : ''}${d}${detalleDiff ? ' ' + detalleDiff : ''}`;
            };
            popup.querySelectorAll('.pm-swal-step').forEach(b => b.addEventListener('click', () => {
                input.value = Math.max(0, (Number(input.value) || 0) + Number(b.dataset.step));
                pintar();
            }));
            input.addEventListener('input', pintar);
            input.addEventListener('keyup', e => { if (e.key === 'Enter') swal.clickConfirm(); });
            pintar();
            input.select();
        },
        preConfirm: () => {
            const v = document.getElementById('pm-swal-input').value;
            if (v === '' || Number(v) < 0 || !Number.isInteger(Number(v))) {
                swal.showValidationMessage('Introduce un número entero mayor o igual a 0');
                return false;
            }
            return Number(v);
        },
    });
    return isConfirmed && value !== actual ? value : null;
}
